import { render } from "./AISummary.vue?vue&type=template&id=78aba8c4&scoped=true"
import script from "./AISummary.vue?vue&type=script&lang=js"
export * from "./AISummary.vue?vue&type=script&lang=js"

import "./AISummary.vue?vue&type=style&index=0&id=78aba8c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78aba8c4"]])

export default __exports__